import React from 'react';
import { Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';
import Layout from '../../../components/layout/Layout';

const CustomDrawer = styled(Drawer)(({ theme }) => ({
    height: '100%',
    '& .MuiPaper-root': {
        overflowX: 'hidden',
        position: 'relative',
        '& .simplebar-content': {
            height: '100%',
        },
        '&:hover': {
            '& span, p': {
                display: 'flex',
            },
        },
        backgroundColor: theme.palette.mode === 'light' ? theme.palette.neutral[50] : theme.palette.neutral[900],
    },
}));

const PageSidebar = (props) => {
    const { collapsed } = props;
    return (
        <CustomDrawer variant="permanent">
            <Layout collapsed={collapsed} />
        </CustomDrawer>
    );
};

export default PageSidebar;
